import { apiClient } from '@/api/client';
import type { UserCreditBalanceResponse, CreditTransactionListResponse } from '@/api/types';

// API Functions
export async function getCreditBalance(): Promise<UserCreditBalanceResponse> {
  const { data } = await apiClient.get('/api/v1/credits/balance');
  return data;
}

export async function getCreditHistory(page: number = 1, pageSize: number = 50): Promise<CreditTransactionListResponse> {
  const { data } = await apiClient.get(`/api/v1/credits/history?page=${page}&page_size=${pageSize}`);
  return data;
}

